import React from 'react';
import PageBuilder from '../components/NewComp/PageBuilder';


class Home2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            wheelDirection: 0,
        };
    }

    render() {  
        return (
            <PageBuilder
            {...this.props} 
                name='home_web2'
            />
        )
    }
}

export default Home2;